import { useSelector } from 'react-redux';
import { CompanyPlanLevel, CompanyPlanStatus } from '../enum/CompanyPlanLevelEnum';

const useCanUseWhatsappNotifications = (): boolean => {
  const { company } = useSelector((state: any) => state.user);
  const isStandardOrPremium = [CompanyPlanLevel.STANDARD, CompanyPlanLevel.PREMIUM].includes(
    company?.planLevel
  );
  const isInGraceOrSuspended = [CompanyPlanStatus.GRACE, CompanyPlanStatus.SUSPENDED].includes(
    company?.planStatus
  );
  const hasCompanyWhatsAppFeatureFlag =
    company?.companyServicesPermissions?.canUseWhatsAppNotifications === true;
  const hasCompanyWhatsAppEnabled =
    company?.communicationSettings?.whatsapp?.enabled === true;

  return (
    isStandardOrPremium &&
    !isInGraceOrSuspended &&
    hasCompanyWhatsAppFeatureFlag &&
    hasCompanyWhatsAppEnabled
  );
};

export default useCanUseWhatsappNotifications;
